module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sectionTitle"
    }
  }, [_vm._v("Section title")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionTitle),
      expression: "sectionTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sectionTitle"
    },
    domProps: {
      "value": (_vm.sectionTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sectionTitle = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])]), _c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "slot": "render",
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    },
    slot: "render"
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse",
      "height": "50px"
    },
    attrs: {
      "width": "319",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "1px solid #efefef"
    }
  }, [_vm._v(" ")])]), _c('tr', [_c('td', [_vm._v(" ")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "480",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center",
      "width": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "",
      "border": "0",
      "height": "15",
      "src": "https://resources.osteopathic.org/l/979203/2023-11-13/c7zt4/979203/1699890535jNe7NLJe/spacer.gif",
      "width": "15"
    }
  })]), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "400",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-family": "helvetica",
      "color": "#22528e",
      "font-weight": "200",
      "padding-bottom": "4px",
      "font-size": "24px",
      "line-height": "28px"
    }
  }, [_vm._v(_vm._s(_vm.sectionTitle))])]), _c('tr', [_c('td', [_vm._v(" ")])])])]), _c('td', {
    attrs: {
      "align": "center",
      "width": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "",
      "border": "0",
      "height": "15",
      "src": "https://resources.osteopathic.org/l/979203/2023-11-13/c7zt4/979203/1699890535jNe7NLJe/spacer.gif",
      "width": "15"
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c07902"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-do/section-title.vue
// module id = 221
// module chunks = 0